<template lang="pug">
  v-container#pricing.fill-height.justify-center(tag="section").pa-0
    v-row
      v-col(cols="12" md="4").text-center
        span.plans__title.pa-3 {{$t('payment.planner.selectNewPlan')}}
        span.plans__description Todos nuestros planes incluyen:
        v-list(disabled='' color='transparent')
          v-list-item-group(v-model='selectedItem' color='primary')
            v-list-item(v-for='(item, i) in features' :key='i' style='max-width: 400px;').mx-auto
              v-list-item-content(style='overflow: visible;')
                v-row(style='display:flex; flex-direction:row; align-items:center;').px-2
                  v-icon(size='35').mr-auto.ml-3 mdi-check-underline-circle-outline
                  span(v-text='item').justify-left
                v-divider(style='min-width: 250px;')
      v-col(cols="12" md="8").my-3
        v-row().justify-center.mb-4
          v-btn(@click="currentType = 'month'" :class="currentType === 'month' ? 'plans__btn':'plans__btn__selected'").mt-4 Plan mensual
          v-btn(@click="currentType = 'year'" :class="currentType === 'year' ? 'plans__btn':'plans__btn__selected'").mt-4 Plan anual
        v-row.justify-center(style='display: flex; flex-wrap: wrap;') <!-- quitar justify-center -->
          v-col(v-for="(plan, i) in plans" :key="i" cols="12" sm="5" v-if="plan.show && plan.type === currentType" ).pa-0.ma-2
            pages-plan-card(:plan="plan")
          v-col.pa-6(v-if="(i === 1 && $vuetify.breakpoint.smAndDown) && i + 1 !== plans.length" :key="`divider-${i}`" cols="12")
            v-divider

</template>

<script>

  export default {
    name: 'Plans',

    components: {
      PagesHeading: () => import('@/views/pages/components/Heading'),
      PagesPlanCard: () => import('@/views/pages/components/PlanCard'),
    },
    data: () => ({
      plans: [],
      currentType: 'month',
      features: [
        'Facturas de venta ilimitadas',
        'Facturas de compra ilimitadas',
        'Gestión de inventarios',
        'Importación de inventarios',
        'Registro de proveedores',
        'Registro de clientes',
        'Información de ventas en tiempo real',
        'Capacitación y soporte',
        'Ventas en tienda virtual sin comisión',
        'Actualizaciones sin costo',
        'Personalización con tu logo y marca',
      ],
    }),
    computed: {
      plan_reactivate () {
        return this.$store.state.payment.plan_reactivate
      },
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    created () {
      // firebase.database().ref('plans/').once('value', snapshot => {
      //   const dataPlans = snapshot.val()
      //   // console.log(dataPlans)
      // }, (error) => {
      //   // console.log(error)
      // })
      const vm = this
      vm.$store.dispatch('payment/getPlansData').then(res => {
        // console.log(res, 'data de los planes')
        res.unshift(vm.plan_reactivate)
        for (let i = 0; i < res.length; i++) {
          let subtitle = ''
          // let subtitlePrice = ''
          const itemList = [
            { text: 'Puntos de Venta: ' + res[i].data.restrictions.salePoints },
            { text: 'Tiendas Virtuales: ' + res[i].data.restrictions.virtualShops },
            { text: 'Usuarios Adicionales: ' + res[i].data.restrictions.collaborators },
          ]
          if (res[i].data.id_plan === 'Plan_Reactivate') {
            itemList.push({ text: 'Limite de Ventas: ' + vm.numberFormat(res[i].data.restrictions.maxAmountSale) })
          }
          if (res[i].data.type === 'year') {
            subtitle = 'Ahorra'
            switch (res[i].data.id_plan) {
              case 'Plan_Business_Anual':
                subtitle = 'Ahorra 60.000 ' + 'USD'
                // subtitlePrice = '$60.000'
                break
              case 'Tender_Business_Anual':
                subtitle = 'Ahorra hasta el 10%'
                // subtitlePrice = '$60.000'
                break
              /* quitar de comentarios
              case 'Plan_Enterprise_Anual':
                subtitle = 'Ahorra $96.000'
                subtitlePrice = '$96.000'
                break
              case 'Plan_Corporate_Anual':
                subtitle = 'Ahorra $144.000'
                subtitlePrice = '$144.000'
                break */
            }
          }
          // sacar vm.plans.push del condicional
          // if (!res[i].data.heading.toUpperCase().includes('PLAN CORPORATE') && !res[i].data.heading.toUpperCase().includes('PLAN ENTERPRISE')) {
          vm.plans.push(
            {
              id_plan: res[i].data.id_plan,
              type: res[i].data.type,
              heading: res[i].data.heading,
              title: res[i].data.title,
              subtitle: subtitle,
              // subtitlePrice: subtitlePrice,
              text: res[i].data.text,
              icon: res[i].data.icon,
              restrictions: res[i].data.restrictions,
              itemList: itemList,
              cost: res[i].data.cost,
              show: res[i].data.show || false,
            },
          )
          // }
        }
        // console.log(vm.plans)
      })
    },
    methods: {
      numberFormat (val) {
        if (val || val === 0) { return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
    },
  }
</script>
<style scoped lang="scss">
  .plans{
    &__title {
      font-size: 1.5rem;
      color: #33a4b8;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 0.2rem;
      display: block;
      margin-bottom: 1rem;
    }

    &__description {
      font-size: 1.2rem;
      color: #a2a2a2;
      font-weight: 400;
      margin-top: .5rem;
      list-style: none;
    }

    &__btn {
      background: #36a2bc !important;
      color: #fff;
      font-weight: 700;
      font-size: 1.2rem;
      border-radius: 10px;

      &__selected {
        background: transparent !important;
        color: #36a2bc !important;
        border: 1px #36a2bc solid;
        font-weight: 700;
        font-size: 1.2rem;
        border-radius: 10px;
      }
    }
  }
</style>
